import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { FlowConfigContext } from '../providers/FlowConfigContext';
import MessagePanel from '../common/components/MessagePanel/MessagePanel';
import { Routes } from '../config/routes';
import withRouteAnalytics from '../services/analytics/withRouteAnalytics';
import { Screens } from '../services/analytics/screens';

function WalletOwnershipScreen(): JSX.Element {
  const navigate = useNavigate();

  const { flowSuccessful } = useContext(FlowConfigContext);
  const onConfirm = () => {
    flowSuccessful();
    navigate(Routes.CONFIRM_WALLET_TRANSACTION);
  };

  return (
    <MessagePanel
      title="screens.ownership.title"
      description="screens.ownership.description"
      buttonLabel="screens.ownership.buttonLabel"
      onConfirm={onConfirm}
      showSupportLink={false}
    />
  );
}
export default withRouteAnalytics(WalletOwnershipScreen, Screens.WALLET_OWNERSHIP);
